module.exports = __webpack_public_path__ + "static/mentor-kiran-b4e13487156ae6bb893ebfa8562aa441.png";